import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
} from "@medme/ui"
import { SidebarHeader as CustomSidebarHeader } from "./SidebarHeader"
import { SidebarNavigation } from "./SidebarNavigation"
import { SidebarUserProfile } from "./SidebarUserProfile"

export function AppSidebar() {
	return (
		<Sidebar className="w-[255px]" variant="sidebar" collapsible="offcanvas">
			<SidebarHeader>
				<CustomSidebarHeader />
			</SidebarHeader>
			<SidebarContent>
				<SidebarNavigation />
			</SidebarContent>
			<SidebarFooter>
				<SidebarUserProfile />
			</SidebarFooter>
		</Sidebar>
	)
}
